import { observer } from 'mobx-react';
import React from 'react';
import { LabelProvider } from 'telia-front-react/label-provider';
import { useStores } from "@stores/RootStore";

interface Props {
  children?: React.ReactElement | React.ReactElement[];
}

const TeliaLabelProvider = (props: Props): React.ReactElement => {
  const { children } = props;
  const { translateStore } = useStores();

  return <LabelProvider labels={translateStore.globalTranslations}>{children}</LabelProvider>;
};

export default observer(TeliaLabelProvider);
